import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CarDetailsCardRevamp from "./component";
import { withRouter } from "react-router-dom";
import { updateSelectedOnScreenFilter, updateAppliedFilters, updateAllFiltersVisibility } from "../filters/actions";
import { reloadCarList, resetCarList } from "../make-filter/actions";
import { setLoginType, updateProfile } from "../../au.configuration/actions";
import { createOrder, updateValidC2bOrder } from "../checkout-info/actions";
import { createTestDriveAvailability } from "../test-drive/wrapper/actions";
import { getOrderDetail } from "../test-drive-v2/actions";
import { setShowHubLocationModal } from "../car-details/actions";

const mapStateToProps = ({
    carDetails: {
        content,
        config: {imageHost}
    },
    deliveryInfo,
    filters: {
        allFilters,
        selectedFilters
    },
    cities: {
        selectedCity
    },
    carDetails: {
        galleryProps: { isOpen: isGalleryOpen }
    },
    user: {secureToken, isUserZeroDpVariant, isLoggedIn},
    checkout: {
        order,
        personalDetails,
        order: { orderId}
    },
    tradeIn: {
        tradeInToggleSelected
    },
    abExperiment: {
        webPriceDropDesktop
    },
    config: {
        testDriveConfig
    }
}) => ({
    content,
    deliveryInfo,
    imageHost,
    allFilters,
    selectedFilters,
    selectedCity,
    isGalleryOpen,
    secureToken,
    order,
    tradeInToggleSelected,
    isUserZeroDpVariant,
    isLoggedIn,
    personalDetails,
    orderId,
    webPriceDropDesktop,
    testDriveConfig
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    updateSelectedOnScreenFilterConnect: updateSelectedOnScreenFilter,
    reloadCarListConnect: reloadCarList,
    updateAllFiltersVisibilityConnect: updateAllFiltersVisibility,
    resetCarListConnect: resetCarList,
    updateAppliedFiltersConnect: updateAppliedFilters,
    setLoginTypeConnect: setLoginType,
    createOrderConnect: createOrder,
    createTestDriveAvailabilityConnect: createTestDriveAvailability,
    updateProfileConnect: updateProfile,
    getOrderDetailConnect: getOrderDetail,
    updateValidC2bOrderConnect: updateValidC2bOrder,
    setShowHubLocationModalConnect: setShowHubLocationModal
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CarDetailsCardRevamp));
